<div class="container">
	<div class="chat_box">
		<div class="head">
			<div class="user">
				<div class="title">
					<mat-icon style="color:#00a2ff;">forum</mat-icon>
					Comentarios ({{comentarios.length}})
				</div>
			</div>
			<mat-icon class="closeModal" (click)="close()">cancel</mat-icon>
			<!--<ul class="bar_tool">
				<li><span class="alink"><i class="fas fa-phone"></i></span></li>
				<li><span class="alink"><i class="fas fa-video"></i></span></li>
				<li><span class="alink"><i class="fas fa-ellipsis-v"></i></span></li>
			</ul>-->
		</div>
		<div class="body" id='comentarios'>
			<div class="incoming" *ngFor="let comentario of comentarios">
				<div class="bubble">
					<span class="name">{{comentario.nombreUsuarioComentario}}</span>
					<p
						style="font-size:13px;"
						>{{comentario.comentarioText}}. <span style="font-weight:bold; font-size:11px;">{{comentario.createdAt | date:'d/M/yy hh:mm'}}</span></p>
				</div>
			</div>
			<!--<div class="outgoing">
				<div class="bubble lower">
					<span class="name">David Valor</span>
					<p>Nah, it's cool.</p>
				</div>
				<div class="bubble">
					<span class="name">David Valor</span>
					<p>Well you should get your Dad a cologne. Here smell it. Oh wait! ...</p>
				</div>
			</div>-->
			<!--<div class="typing">
				<div class="bubble">
					<div class="ellipsis dot_1"></div>
					<div class="ellipsis dot_2"></div>
					<div class="ellipsis dot_3"></div>
				</div>
			</div>-->
		</div>
		<div class="foot">
			<textarea
				[(ngModel)]='comentario'
				type="text"
				class="msg"
				placeholder="Comentar"
			></textarea>
			<button
				type="submit"
				(click)="createComentario()"
				[disabled]='comentario == ""'
			>
				<i class="fas fa-paper-plane"></i>
			</button>
		</div>
	</div>
</div>
